<template>
  <div class="modal__wrapper" :class="{ 'modal__wrapper--visible': isVisible }">
    <div class="modal" @clickaway="modalClose">
      <div class="modal__header">
        <div class="modal__label">
          <unicon name="bell" width="40" height="40" :fill="SKIN"></unicon>
          <span class="modal__label-text">Notification</span>
        </div>
        <unicon name="times" width="40" height="40" @click="modalClose"></unicon>
      </div>
      <div class="modal__content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import clickaway from "vue-clickaway";
import { colors } from "../constants/colors";

export default {
  mixins: [clickaway],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ ...colors }),
  methods: {
    modalClose() {
      this.$emit("close");
    },
    runClosingTimer() {
      const TIME_TO_WAIT = 1500;

      setTimeout(() => {
        this.modalClose();
      }, TIME_TO_WAIT);
    }
  },
  watch: {
      "isVisible": function(value) {
          value && this.runClosingTimer();
      },
  }
};
</script>